export default "__VITE_ASSET__CDN$7rkA__"